/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
"use client";
import {
  FieldErrors,
  UseFormClearErrors,
  UseFormRegister,
} from "react-hook-form";
import InputField from "../../../components/common/InputField";
import { useEffect, useState } from "react";
import {
  useFetchCountriesAllData,
  useFetchCountryCitiesAllData,
} from "../../../apis/locationApis";
import SelectInput from "../../../components/Select";

export const SystemTypes = [
  { value: "phone", text: "Phone" },
  { value: "email", text: "Email" },
  { value: "whatsapp", text: "WhatsApp" },
];

type FormValues = {
  name: string;
  mobileNo: string;
  email: string;
  licenseNumber: string;
  licenseExpiry: string;
  countryId: string;
  cityId: string;
  image: string;
  document: string;
  status?: string;
  districtId: string;
  warehouseId: string;
};

type Props = {
  register: UseFormRegister<FormValues>;
  errors: FieldErrors<FormValues>;
  clearErrors?: UseFormClearErrors<any>;
  setValue?: any;
  getIds?: any;
  watch?: any;
};

const AddOutSorceDriverModal = ({
  register,
  errors,
  clearErrors,
  setValue,
  getIds,
  watch,
}: Props) => {
  const [selectedCountry, setSelectedCountry] = useState<any>();
  const [selectedCity, setSelectedCity] = useState<any>();
  const { data } = useFetchCountriesAllData();
  const { data: cities, refetch: fetchData } = useFetchCountryCitiesAllData(
    selectedCountry?.id
  );

  useEffect(() => {
    if (selectedCountry) {
      fetchData();
    }
  }, [selectedCountry]);

  useEffect(() => {
    if (selectedCity && selectedCountry) {
      getIds({
        cityId: selectedCity?.id,
        countryId: selectedCountry?.id,
      });
    }
  }, [selectedCity, selectedCountry]);

  return (
    <div className="w-[655px] max-h-[520px] overflow-y-auto overflow-hidden p-4 space-y-4">
      <div className="grid grid-cols-6 gap-4">
        <SelectInput
          label="Select Company"
          className="col-span-3"
          placeholder="Select Company"
          selectOptions={[]}
          name={""}
        />
        <SelectInput
          name=""
          className="col-span-3"
          label="Select Driver"
          placeholder="Select Driver"
          selectOptions={[]}
        />

        <InputField
          label="Driver Code"
          className="col-span-3 "
          type="number"
          placeholder="#897465100"
        />
        <InputField
          label="Start Date"
          className="col-span-3 "
          type="date"
          placeholder="April 17th, 2026"
        />
         <SelectInput
          label="Select Warehouse"
          className="col-span-3"
          placeholder="Select Warehouse"
          selectOptions={[]}
          name={""}
        />
         <SelectInput
          label="City"
          className="col-span-3"
          placeholder="City"
          selectOptions={[]}
          name={""}
        />
         <SelectInput
          label="Select Vehicle Type"
          className="col-span-3"
          placeholder="Select Vehicle Type"
          selectOptions={[]}
          name={""}
        />
         <SelectInput
          label="Assign Vehicle"
          className="col-span-3"
          placeholder="Assign Vehicle"
          selectOptions={[]}
          name={""}
        />
      </div>
    </div>
  );
};

export default AddOutSorceDriverModal;
